<template>
  <div>
    <!--头部开始-->
    <div class="header">
      <div class="container">
        <div class="logo" style="margin-top: -50px;"> <a href=""><img width="800px" src="@/assets/skin/images/logo4.png" alt="泰安市医师协会" /></a> </div>
        <div style="margin-left: 900px;margin-top: 40px;">
          <ul v-if="state.state.user==null" style="display: flex;" @click="btnLogin">
            <li>
              <el-avatar :size="40" src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"></el-avatar>
            </li>
            <li style="margin-top: 15px;margin-left: 10px;width: 200px;">
              <h1>未登录</h1>
            </li>
          </ul>
          <ul @click="btnSignOut" style="display: flex;" v-else>
            <li>
              <el-avatar :size="40" :src="state.state.frontUrl+'/images/'+state.state.user.avatar"></el-avatar>
            </li>
            <li style="margin-top: 15px;margin-left: 10px;width: 100%;">
              <h1>{{state.state.user.loginName}}</h1>
            </li>
            <li style="margin-top: 14px">
              <el-header style="text-align: right; font-size: 12px;margin-right: 200px;">
                <el-dropdown @command="btnSignOut">
                  <i class="el-icon-setting" style="margin-right: 15px;font-size: 20px"></i>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="signOut">退出登录</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>

              </el-header>
            </li>
          </ul>

        </div>
        <!--搜索栏开始-->
        <div class="search" style="margin-top: 10px;">
          <form>
            <input type="hidden" name="kwtype" value="0" placeholder="请输入关键字" />
            <img src="@/assets/skin/images/search.png" alt="" style="position: absolute;width: 18px;height: 18px;margin-left: 8px;">
            <input class="ipt-sea" type="text" name="q" placeholder="请输入关键字" v-model="search.name" value="请输入关键字" onfocus="if(this.value==defaultValue)this.value=''" onblur="if(this.value=='')this.value=defaultValue" />

            <input class="search_btn" value="搜 索" name="submit" type="submit" @click="btnSearch" />
          </form>
        </div>

        <!--搜索栏结束-->
      </div>
    </div>
    <!--头部结束-->
    <!--导航开始-->
    <div class="nav">
      <ul id="navul" style="display: flex;justify-content:center;margin-top: -40px;" >
        <li :class="state.state.navsActive==index? 'active' :'' " v-for="(item1,index) in navList" :key="index">
          <a href="javascript:void(0);" @click="btnNavs(item1,index)" :title="item1.name">
            <!-- <img :src="item1.image"
              :alt="item1.name" /> -->
            <span style="font-size: 16px;">{{item1.name}}</span> </a>
          <div class="subnav">
            <a style="font-size: 16px;" href="javascript:void(0);" v-for="(item2,index2) in  item1.children" :key="index2" @click="btnNavSon(item1,item2,index)" :title="item2.name">{{item2.name}}</a>
          </div>
        </li>

      </ul>
      <div class="clearfix"></div>
    </div>
    <!--导航结束-->
  </div>
</template>
<script>

import * as header from "@/api/header.js";
import store from "@/store";


export default {
  name: "Header",
  data() {
    return {
      state: store,
      navsActive: 0,
      search: {
        name: "",
        total: 5,
        size: 10,
        current: 1,
      },
      navList: [
      ],
    };
  },
  mounted() {

    header.loadNavs().then(res => {
      this.navList = res.data
      store.commit("SET_NAVS", res.data)
      localStorage.setItem('SET_NAVS', res.data);
    });
  },
  methods: {
    btnSearch(e) {
      // 取消默认行为
      e.preventDefault();
      btnSearchAction(this)
    },
    btnLogin() {
      this.$router.push("/MemberRegistered")
    },
    btnSignOut(item) {
      console.log()
      if (item == "signOut") {
        store.commit('SET_TOKEN', '')
        store.commit('SET_USER', null)
        localStorage.setItem('SET_TOKEN', "");
        localStorage.setItem('SET_USER', null);
        this.$router.push("/MemberRegistered")
      }
    },
    btnNavs(item, index) {
      // this.navsActive = index
      store.commit("SET_NAVS_ACTIVE", index)

      localStorage.setItem('SET_NAVS_ACTIVE', index);
      console.log(213321, item)
      //单页面
      if (item.path == '/ContactUs') {
        this.$router.push('/ContactUs')
      } else if (item.children.length > 0 && item.children[0].type == "ARTICLE") {
        this.$router.push(item.children[0].path + `/${item.id}/${item.children[0].id}`)

      } else {
        // 正常
        this.$router.push(item.path + `/${item.id}/${item.children.length > 0 ? item.children[0].id : ''}`)
      }


    },
    btnNavSon(item1, item2, index) {
      // this.navsActive = index
      store.commit("SET_NAVS_ACTIVE", index)
      localStorage.setItem('SET_NAVS_ACTIVE', index);
      if (item1.path == '/ContactUs') {
        this.$router.push('/ContactUs')
      } else {
        this.$router.push(item2.path + `/${item1.id}/${item2.id}`)
      }

    },
  }
};

function btnSearchAction(vm) {
  vm.$router.push('/SearchPage' + `/${store.state.navIndex++}`)

  store.commit("SET_SEARCH_NAME", vm.search.name)

}
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Header.vue